export let SystemConfig = {
    path: 'system-config',
    name: 'system-config',
    meta: {
        roleCode: '015',
    },
    component: () =>
        import(/* webpackChunkName: "system-config-page" */ '@/views/back-stage/system-config/system-config.vue'),
};
